import { render, staticRenderFns } from "./nav-main.html?vue&type=template&id=f703d53c&scoped=true&"
import script from "./nav-main.js?vue&type=script&lang=js&"
export * from "./nav-main.js?vue&type=script&lang=js&"
import style0 from "./nav-main.scss?vue&type=style&index=0&id=f703d53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f703d53c",
  null
  
)

export default component.exports